import Vue from "@src/libraries/vue";
import localesStore from "@src/store/locales";
export default Vue.extend({
    name: "DefaultLayout",
    data() {
        return {
            loginModel: false,
            newAccountModel: false,
            email: "",
            pswd: "",
        };
    },
    computed: {
        loginLink() {
            return localesStore.localePath(`login`);
        },
    },
});
